import Badge from '../../../common/component/Badge';
import SingleText from '../../../common/component/SingleText';

interface IProps {
  hintLabel: string;
  hint: string;
}

export default function QuizHintV4({hintLabel, hint}: IProps) {
  return (
    <div className="flex items-center overflow-hidden gap-x-5">
      <Badge variant="s10_white_black_03" label={hintLabel} className="!px-4" />
      <SingleText className="s13-regular-white leading-16 tracking-[-0.4px] max-w-[236px]">
        {hint}
      </SingleText>
    </div>
  );
}
